import React from 'react';
import { Link } from 'react-router';

// August 6th: refactored for responsiveness
const Rules = () => {
    return (
        <div className="w3-container d-flex flex-column justify-content-center" style={{
            height: 300,
            background: 'url("/images/backgrounds/carajitos_de_espalda.jpg") no-repeat center top', backgroundSize: 'cover'
        }}>
            <span className="anton hero-text align-self-center">RULES</span>
            <Link to="/rules" className="btn-transparent margin-top text-center align-self-center">VIEW MORE</Link>
        </div>
    );
}

export default Rules;



// WEBPACK FOOTER //
// ./src/components/information/partials/rules.js